import React from "react";
import { colors } from "../../../styles/common";
export const ArrowUpIcon = (props) => {
    const { fillColor = colors.lightGray, overideStyle = {} } = props;
    return (<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={overideStyle}>
			<path d="M5.72559 0.953719L1.11308 5.57902C0.962049 5.73056 0.962303 5.97591 1.11386 6.1272C1.26541 6.27837 1.51089 6.27798 1.66205 6.12642L6.00002 1.77643L10.338 6.12658C10.4891 6.27812 10.7345 6.27851 10.886 6.12736C10.962 6.05152 11 5.95216 11 5.85281C11 5.75371 10.9623 5.65474 10.8868 5.57904L6.27443 0.953719C6.20181 0.880731 6.10299 0.839774 6.00002 0.839774C5.89705 0.839774 5.79834 0.880848 5.72559 0.953719Z" fill="white" stroke={fillColor}/>
		</svg>);
};
